import { render, staticRenderFns } from "./UpgradeAccountPopover.vue?vue&type=template&id=5c1f4381&"
import script from "./UpgradeAccountPopover.vue?vue&type=script&lang=js&"
export * from "./UpgradeAccountPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports